// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoiceReceipt_upper__metrics__BSIqR {
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
}
@media only screen and (max-width: 62.5em) {
  .InvoiceReceipt_upper__metrics__BSIqR {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 56.25em) {
  .InvoiceReceipt_upper__metrics__BSIqR {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .InvoiceReceipt_upper__metrics__BSIqR {
    grid-template-columns: repeat(2, 1fr);
  }
}
.InvoiceReceipt_upper__metrics_invoicesCreated__NzaA6 {
  background-color: var(--color-primary-3);
  color: var(--color-admin-2);
}
.InvoiceReceipt_upper__metrics_fullyPaidInvoices__dFA7Q {
  background-color: var(--color-green);
  color: var(--color-white);
}
.InvoiceReceipt_upper__metrics_unpaidInvoices__6gVZD {
  background-color: #E0E9F3;
  color: #071530;
}
.InvoiceReceipt_upper__metrics_overdueInvoices__LA3H- {
  background-color: var(--color-error);
  color: var(--color-white);
}
.InvoiceReceipt_upper__metrics_invoicesCreated__NzaA6 {
  background-color: #CCEDFF;
  color: #071530;
}
.InvoiceReceipt_upper__metrics_partiallyPaidInvoices__ge3pu {
  background-color: #F3E6A2;
  color: #071530;
}
.InvoiceReceipt_upper__metrics_receiptsCreated__-MLu2 {
  background-color: #C1DAFF;
  color: #071530;
}

.InvoiceReceipt_searchInMiddle__dR2lB {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 3rem;
}

.InvoiceReceipt_modal__wttNa {
  width: 38rem;
}
.InvoiceReceipt_modal__wttNa > :not(:last-child) {
  margin-bottom: 1rem;
}
.InvoiceReceipt_modal__beside__RqBTr {
  display: flex;
  justify-content: space-between;
}

.InvoiceReceipt_main_nav__cRPa2 {
  display: flex;
  margin: 2rem 0;
  border-bottom: solid 1px var(--color-dark);
  gap: 2rem;
  width: fit-content;
}
.InvoiceReceipt_main_nav_item__UvZQv {
  cursor: pointer;
  padding: 1rem 0;
  font-size: var(--default-font-small);
}
.InvoiceReceipt_main_nav_item_active__ffc55 {
  cursor: pointer;
  padding: 1rem 0;
  font-weight: 700;
  border-bottom: solid 2px var(--color-dark);
}
.InvoiceReceipt_main_nav_item__UvZQv:hover, .InvoiceReceipt_main_nav_item__UvZQv:focus, .InvoiceReceipt_main_nav_item__UvZQv:focus-visible, .InvoiceReceipt_main_nav_item__UvZQv:focus-within {
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/InvoiceReceipt/InvoiceReceipt.module.scss"],"names":[],"mappings":"AAGC;EACC,sBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAFF;AAIE;EARD;IASE,qCAAA;EADD;AACF;AAGE;EAZD;IAaE,qCAAA;EAAD;AACF;AAEE;EAhBD;IAiBE,qCAAA;EACD;AACF;AACE;EACC,wCAAA;EACA,2BAAA;AACH;AAEE;EACC,oCAAA;EACA,yBAAA;AAAH;AAGE;EACC,yBAAA;EACA,cAAA;AADH;AAIE;EACC,oCAAA;EACA,yBAAA;AAFH;AAKE;EACC,yBAAA;EACA,cAAA;AAHH;AAME;EACC,yBAAA;EACA,cAAA;AAJH;AAOE;EACC,yBAAA;EACA,cAAA;AALH;;AAUA;EACC,aAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AAPD;;AAUA;EACC,YAAA;AAPD;AAQC;EACC,mBAAA;AANF;AASC;EACC,aAAA;EACA,8BAAA;AAPF;;AAYC;EACC,aAAA;EACA,cAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;AATF;AAWE;EACC,eAAA;EACA,eAAA;EACA,oCAAA;AATH;AAWG;EACC,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;AATJ;AAYG;EAIC,gBAAA;AAbJ","sourcesContent":["@import '../variables/breakpoints';\n\n.upper {\n\t&__metrics {\n\t\tbox-sizing: border-box;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t\tgap: 1rem;\n\t\tmargin-bottom: 1rem;\t\t\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\n\t\t&_invoicesCreated {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\tcolor: var(--color-admin-2);\n\t\t}\n\n\t\t&_fullyPaidInvoices {\n\t\t\tbackground-color: var(--color-green);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_unpaidInvoices {\n\t\t\tbackground-color:#E0E9F3;;\n\t\t\tcolor: #071530;\t\t\t\n\t\t}\n\n\t\t&_overdueInvoices {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_invoicesCreated {\n\t\t\tbackground-color: #CCEDFF;\n\t\t\tcolor: #071530;\n\t\t}\n\n\t\t&_partiallyPaidInvoices {\n\t\t\tbackground-color:#F3E6A2;\n\t\t\tcolor: #071530;\n\t\t}\n\n\t\t&_receiptsCreated {\n\t\t\tbackground-color:#C1DAFF;\n\t\t\tcolor: #071530;\n\t\t}\n\t}\n}\n\n.searchInMiddle {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n\tmargin-top: 3rem;\n}\n\n.modal {\n\twidth: 38rem;\n\t& > :not(:last-child) {\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n}\n\n.main {\n\t&_nav {\n\t\tdisplay: flex;\n\t\tmargin: 2rem 0;\n\t\tborder-bottom: solid 1px var(--color-dark);\t\t\n\t\tgap: 2rem;\n\t\twidth: fit-content;\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tborder-bottom: solid 2px var(--color-dark);\n\t\t\t}\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upper__metrics": `InvoiceReceipt_upper__metrics__BSIqR`,
	"upper__metrics_invoicesCreated": `InvoiceReceipt_upper__metrics_invoicesCreated__NzaA6`,
	"upper__metrics_fullyPaidInvoices": `InvoiceReceipt_upper__metrics_fullyPaidInvoices__dFA7Q`,
	"upper__metrics_unpaidInvoices": `InvoiceReceipt_upper__metrics_unpaidInvoices__6gVZD`,
	"upper__metrics_overdueInvoices": `InvoiceReceipt_upper__metrics_overdueInvoices__LA3H-`,
	"upper__metrics_partiallyPaidInvoices": `InvoiceReceipt_upper__metrics_partiallyPaidInvoices__ge3pu`,
	"upper__metrics_receiptsCreated": `InvoiceReceipt_upper__metrics_receiptsCreated__-MLu2`,
	"searchInMiddle": `InvoiceReceipt_searchInMiddle__dR2lB`,
	"modal": `InvoiceReceipt_modal__wttNa`,
	"modal__beside": `InvoiceReceipt_modal__beside__RqBTr`,
	"main_nav": `InvoiceReceipt_main_nav__cRPa2`,
	"main_nav_item": `InvoiceReceipt_main_nav_item__UvZQv`,
	"main_nav_item_active": `InvoiceReceipt_main_nav_item_active__ffc55`
};
export default ___CSS_LOADER_EXPORT___;
